import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Header from "../components/Header";
import DynamicChildren from "../components/DynamicChildren";

const Page = ({ location, data: { page } }) => {
    const pageClassName = location.pathname.replace(/\//g, " ").trim();

    return (
        <Layout className={pageClassName} location={location}>
            <Header
                header={page.header}
                compact={!page.header?.heroImage}
                banner={page.banner}
                location={location}
            />

            <DynamicChildren contentfulComponents={page.dynamicComponents} />
        </Layout>
    );
};

export const Head = ({ data: { page } }) => {
    const meta = [];

    if (page.header?.heroImage?.url) {
        meta.push({
            key: "og:image",
            property: "og:image",
            content: page.header.heroImage.url,
        });
    }

    return <Seo page={page} meta={meta} />;
};

export const query = graphql`
    query PageQuery($slug: String) {
        page: contentfulPage(path: { eq: $slug }) {
            header {
                ...HeaderData
            }
            banner {
                ...Banner
            }
            ...DynamicComponents
            seoTitle
            seoDescription {
                seoDescription
            }
            seoRobots
        }
    }
`;

export default Page;
